module.exports = __webpack_public_path__ + "img/commandeManuelSuivi.9d253f6d.png";